import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useRoomsSearchParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const academicYear = searchParams.get('academicYear');
    const developmentSlug = searchParams.get('development');
    const moveInDate = searchParams.get('moveInDate');
    const duration = searchParams.get('duration');

    const hasPartialSearchParams = Boolean(moveInDate) !== Boolean(duration);

    const applySearch = useCallback(
        (newMoveInDate: string, newDuration: number) => {
            setSearchParams(
                (params) => {
                    params.set('moveInDate', newMoveInDate);
                    params.set('duration', String(newDuration));

                    return params;
                },
                { replace: true }
            );
        },
        [setSearchParams]
    );

    const clearSearch = useCallback(() => {
        setSearchParams((params) => {
            params.delete('moveInDate');
            params.delete('duration');

            return params;
        });
    }, [setSearchParams]);

    return {
        academicYear,
        developmentSlug,
        moveInDate,
        duration,
        hasPartialSearchParams,
        applySearch,
        clearSearch,
    };
};
